module.exports = __webpack_public_path__ + "media/packs/images/flags/PK-6a2eeb71ded965026caf260025367a06.svg";